import React from 'react';
import { Modal, NamedLink, Icon } from '../../components';
import { FormattedMessage } from '../../util/reactIntl';

import css from './ListingPage.module.css';

const SuccessPostingModal = props => {
  const {
    containerClassName,
    contentClassName,
    id,
    listingId,
    orgId,
    location,
    isOpen,
    onCloseModal,
    onManageDisableScrolling,
    listingState,
  } = props;
  const isPendingApproval = listingState === 'pendingApproval';

  // The new spec routes the "next step" to the Org's Assignments tab —
  // creators own Live Rooms, the org assigns one of theirs to this Show.
  // If we don't have an orgId on the listing (legacy show), fall back to
  // the old draft-Live-Room flow so the modal still has a working CTA.
  const hasOrgContext = !!orgId;
  const editParams = {
    slug: 'draft',
    id: '00000000-0000-0000-0000-000000000000',
    type: 'new',
    tab: 'details',
  };

  return (
    <Modal
      id={id}
      containerClassName={containerClassName}
      contentClassName={contentClassName}
      isOpen={isOpen}
      onClose={onCloseModal}
      onManageDisableScrolling={onManageDisableScrolling}
    >
      <Icon name="celebrate" size={48} className={css.modalIcon} />
      <h1 className={css.modalTitle}>
        <FormattedMessage
          id={
            isPendingApproval
              ? 'ListingPage.successPostingModalTitlePendingApproval'
              : 'ListingPage.successPostingModalTitle'
          }
        />
      </h1>
      <p className={css.modalMessage}>
        <FormattedMessage
          id={
            isPendingApproval
              ? 'ListingPage.successPostingModalMessagePendingApproval'
              : 'ListingPage.successPostingModalMessage'
          }
        />
      </p>
      {!isPendingApproval && (
        <>
          <p className={css.modalMessage}>
            <FormattedMessage id="ListingPage.successPostingModalNextStepHeading" />
          </p>
          <ul className={css.modalNextSteps}>
            <li>
              <FormattedMessage id="ListingPage.successPostingModalStepAssign" />
            </li>
            <li>
              <FormattedMessage id="ListingPage.successPostingModalStepBoost" />
            </li>
            <li>
              <FormattedMessage id="ListingPage.successPostingModalStepReview" />
            </li>
          </ul>
          {hasOrgContext ? (
            <NamedLink
              className={css.modalButton}
              name="OrgSettingsAssignmentsPage"
              params={{ orgId }}
            >
              <FormattedMessage id="ListingPage.successPostingModalAssignButton" />
            </NamedLink>
          ) : (
            <NamedLink
              className={css.modalButton}
              name="EditLiveRoomPage"
              params={editParams}
              to={{
                state: {
                  from: `${location.pathname}${location.search}${location.hash}`,
                  showId: listingId.uuid,
                },
              }}
            >
              <FormattedMessage id="ListingPage.successPostingModalButtonText" />
            </NamedLink>
          )}
        </>
      )}
    </Modal>
  );
};

export default SuccessPostingModal;
